import React from 'react';
import { PlayerDuelStatsWrapper, StatsDividerWrapper, PlayerDuelStatsDash } from '../PlayerDuel.style';
import getStatsText from './getStatsText';

const buildPlayerStatsDuel = (desiredStats, statsMap, stats, dictMap, isPitcher, requiresBreak) => {
    const {
        beforeList = [],
        afterList = [],
        beforeText = '',
        bottomList = [],
        beforeSeparator,
        afterSeparator
    } = getStatsText(desiredStats, statsMap, stats, dictMap, isPitcher);

    const beforeListText = beforeText || beforeList.join(beforeSeparator);
    const afterListText = afterList.join(afterSeparator);
    return (
        <PlayerDuelStatsWrapper>
            <span className='before-list'>{beforeListText}</span>
            {requiresBreak && <br />}
            {requiresBreak && beforeListText && !afterListText && (
                <PlayerDuelStatsDash>-</PlayerDuelStatsDash>
            )}
            {!requiresBreak && beforeListText && afterListText && (
                <StatsDividerWrapper>|</StatsDividerWrapper>
            )}
            <span className='after-list'>{afterListText}</span>
            {bottomList.length > 0 &&
                <div>
                    <span className='bottom-list'>{bottomList.join('')}</span>
                </div>
            }
        </PlayerDuelStatsWrapper>
    );
};

export default buildPlayerStatsDuel;
